import { Button, Table } from '@tmov/design-system';
import { WaveVariantB } from '@tmov/design-system/icons';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { LoadingContainer } from '../../../../components/LoadingContainer';
import StatusCotacaoEnum from '../../Enum/StatusCotacaoEnum';
import ModalVencedor from '../ModalVencedor';
import { getColumns } from './getColumns';
import {
  Header,
  HeaderRight,
  PropostaHeader,
  PropostaSubtitle,
  TableContainer,
} from './styles';

const PropostaTable = ({
  idCotacao,
  cotacaoStatus,
  cotacaoValorFinal,
  fetchProposta,
  propostaData,
  setPropostaData,
  loadingPropostaData,
}) => {
  const [sorter, setSorter] = useState({});

  const [modalVisible, setModalVisible] = useState();
  const [isVencedorValid, setIsVencedorValid] = useState(true);

  const MINUTE_MS = 60000;

  const handleOnChange = (value, id) => {
    const propostaAtualizada = propostaData.map(proposta => {
      if (proposta.id === id) {
        proposta.aprovada = value;
      }
      return proposta;
    });

    setPropostaData(propostaAtualizada);
  };

  const handleVencedor = async () => {
    setModalVisible(true);
  };

  const columnsTable = getColumns(
    handleOnChange,
    cotacaoStatus,
    cotacaoValorFinal
  );

  useEffect(() => {
    const onInit = async () => {
      setIsVencedorValid(true);
      if (propostaData) {
        propostaData.forEach(item => {
          if (item.aprovada === true) {
            setIsVencedorValid(false);
          }
        });
      }
    };
    onInit();
  }, [propostaData, cotacaoStatus]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (cotacaoStatus !== StatusCotacaoEnum.EM_ANDAMENTO) return;
      fetchProposta();
    }, MINUTE_MS);
    return () => clearInterval(interval);
  }, [cotacaoStatus]);

  return (
    <TableContainer>
      {!loadingPropostaData ? (
        <>
          <Header>
            <HeaderRight>
              {cotacaoStatus === StatusCotacaoEnum.ENCERRADO &&
                cotacaoValorFinal === null && (
                  <Button onClick={handleVencedor} disabled={isVencedorValid}>
                    {' '}
                    Selecionar vencedor
                  </Button>
                )}
            </HeaderRight>
            <PropostaHeader>Lances</PropostaHeader>
            <PropostaSubtitle>
              {cotacaoStatus !== StatusCotacaoEnum.ENCERRADO &&
                cotacaoValorFinal === null &&
                'Atualizado a cada minuto.'}
            </PropostaSubtitle>
          </Header>

          <Table
            rows={propostaData}
            columns={columnsTable}
            sorting={{
              sorter,
              updateSorter: setSorter,
            }}
          />

          <ModalVencedor
            modalVisible={modalVisible}
            handleClose={() => setModalVisible(false)}
            propostaData={propostaData}
            idCotacao={idCotacao}
          />
        </>
      ) : (
        <LoadingContainer height="10vh">
          <WaveVariantB size="60px" />
        </LoadingContainer>
      )}
    </TableContainer>
  );
};

PropostaTable.propTypes = {
  idCotacao: PropTypes.string.isRequired,
  cotacaoStatus: PropTypes.number,
  cotacaoValorFinal: PropTypes.number,
  fetchProposta: PropTypes.func.isRequired,
  propostaData: PropTypes.arrayOf(PropTypes.object).isRequired,
  setPropostaData: PropTypes.func.isRequired,
  loadingPropostaData: PropTypes.bool.isRequired,
};

PropostaTable.defaultProps = {
  cotacaoStatus: null,
  cotacaoValorFinal: null,
};

export default PropostaTable;
